'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'signal-stream';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f8dd';
var svgPathData = 'M288 192c-35.38 0-64 28.62-64 63.1s28.62 63.1 64 63.1s64-28.62 64-63.1S323.4 192 288 192zM288 288c-17.62 0-32-14.37-32-31.1s14.38-31.1 32-31.1s32 14.37 32 31.1S305.6 288 288 288zM32 256c0-62.19 24.17-120.7 68.05-164.7C106.3 85.04 106.3 74.92 100 68.67c-6.25-6.187-16.38-6.219-22.62 .0625C27.48 118.8 0 185.3 0 256s27.48 137.2 77.39 187.3C80.52 446.4 84.61 448 88.72 448c4.078 0 8.172-1.562 11.3-4.656c6.25-6.25 6.281-16.37 .0313-22.62C56.17 376.7 32 318.2 32 256zM498.6 68.73c-6.25-6.312-16.38-6.281-22.62-.0625c-6.25 6.25-6.281 16.37-.0313 22.62C519.8 135.4 544 193.8 544 256s-24.17 120.7-68.05 164.7c-6.25 6.25-6.219 16.37 .0313 22.62C479.1 446.4 483.2 448 487.3 448c4.109 0 8.203-1.562 11.33-4.719C548.5 393.2 576 326.7 576 256S548.5 118.8 498.6 68.73zM167.5 132.4c-6.438-6.094-16.56-5.75-22.61 .625C113.4 166.4 96 210.1 96 256s17.36 89.62 48.88 122.1c3.141 3.312 7.375 4.1 11.62 4.1c3.938 0 7.891-1.437 10.98-4.375c6.422-6.062 6.719-16.19 .6406-22.62C142.3 329.6 128 293.8 128 256s14.25-73.62 40.13-100.1C174.2 148.6 173.9 138.4 167.5 132.4zM431.1 133c-6.062-6.375-16.16-6.719-22.61-.625c-6.422 6.062-6.719 16.19-.6406 22.62C433.8 182.4 448 218.3 448 256s-14.25 73.63-40.13 100.1c-6.078 6.437-5.781 16.56 .6406 22.62c3.094 2.937 7.047 4.375 10.98 4.375c4.25 0 8.484-1.687 11.62-4.1C462.6 345.6 480 301.9 480 256S462.6 166.4 431.1 133z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSignalStream = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;